import { render, staticRenderFns } from "./m-surplus-second-confirm.vue?vue&type=template&id=0022adeb&"
import script from "./m-surplus-second-confirm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-surplus-second-confirm.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-surplus-second-confirm.vue?vue&type=style&index=0&id=0022adeb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports